var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"building-container"},[_c('el-empty',{attrs:{"image":_vm.image,"image-size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }